export default {
  headerContent: {
    title: 'Quick Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Konut Sigortası',
    description: {
      title: 'Quick Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Konut sigortası, konut ve konut içerisinde bulanan eşyalarda oluşabilecek risklere karşı güvence sağlamaktadır.',
        'Konut sigortası yangın, hırsızlık ve deprem gibi risklerin oluşması sonucu oluşacak maddi kayıplara karşı binanızı ve bütçenizi koruma altına almaktadır.',
        'İster mal sahibi, ister kiracı olun Quick Konut Sigortası ile hem binanızı hem de eşyalarınızı güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Konut Sigortası Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Quick Sigorta’dan konut sigortası yaptıran sigortalıların yararlanabileceği avantajlar arasında;ulan teminatlar:',
          subList: [
            'Kombi Bakımı',
            'Klima Bakımı',
            'Halı Yıkama Hizmeti yer almaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
